import React, { useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { supabase } from '../Utils/supabase';

const ProtectedRoute = () => {
  const { user, loading } = useAuth();

  useEffect(() => {
    // Check if user exists but doesn't have admin role
    if (user && user.role !== 'admin') {
      // Sign out unauthorized users
      supabase.auth.signOut();
    }
  }, [user]);

  if (loading) {
    return (
      <div className="loading-container">
        <div>Loading...</div>
      </div>
    );
  }

  // Only allow users with admin role
  if (!user || user.role !== 'admin') {
    return <Navigate to="/login?error=unauthorized" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
